import { EditOutlined, CloseOutlined, UndoOutlined } from "@ant-design/icons";
import { Space, Typography, Popconfirm, Form } from "antd";
import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  appTitle,
  dateFormat,
  MonthsPortuguese,
  Departement,
} from "../common/GeneralConfigurations";

import { EmployeeFollowUpEventListForm } from "./EmployeeFollowUpEventListForm";
import { AdnStar } from "../common/adnStar/AdnStar";
import moment from "moment";
import AdnTable from "../common/adnTable/AdnTable";
import AdnDropdown from "../common/adnDropdown/AdnDropdown";
import {
  getEmployeeFollowUpEventList,
  getEmployeeFollowUpEventsByDate,
  generateAnnualReport,
  getEmployeeFollowUpEventById,
  updateEmployeeFollowUpEvent,
  checkPreviousUnresolvedEmployeeFollowUpEventsById,
  reset
} from "../../api/EmployeeFollowUpEventApi";
import { GetUserByDepartmentId, getUserById } from "../../api/UserApi";
import { AppRoutes } from "../../AppRoutes";
import { getFollowUpEventList } from "../../api/FollowUpEventApi";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import { getAuthenticatedUserId } from "../../api/ApiUtils";
import { Link } from "react-router-dom";

export const ManageEmployeeFollowUpEventListPage = () => {
  const { t } = useTranslation();
  const { Text } = Typography;
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const title = t("manageEmployeeFollowUpEventList.title");
  const employeePlaceholder = t(
    "manageEmployeeFollowUpEventList.placeholders.searchConsultant"
  );
  const doneByPlaceholder = t(
    "manageEmployeeFollowUpEventList.placeholders.searchDoneBy"
  );

  const userName = searchParams.get("username")
    ? searchParams.get("username")
    : "";
  const consultantName = searchParams.get("consultant")
    ? searchParams.get("consultant")
    : "";
  const followUpEventMonth = searchParams.get("month")
    ? searchParams.get("month")
    : moment().format("M");
  const followUpEventYear = searchParams.get("year")
    ? searchParams.get("year")
    : moment().format("YYYY");
  const followUpEventDone = searchParams.get("status")
    ? searchParams.get("status") === "Done"
      ? 2
      : searchParams.get("status") === "Not assigned"
      ? 0
      : searchParams.get("status") === "Not done"
      ? 1
      : 3
    : 0;
  const followUpEventType = searchParams.get("type")
    ? searchParams.get("type")
    : "";

  const [initValues, setInitValues] = useState({
    id: null,
    employeeId: null,
    followUpEventId: null,
    date: undefined,
    feedBack: "",
    note: "",
    status: 0,
    doneById: null,
    companyLevel: null,
    clientLevel: null,
    projectLevel: null,
    createdBy: null,
    createdAt: "",
    updatedBy: null,
    updatedAt: "",
    employeeName: "",
    eventType: "",
    doneByName: "",
    authenticatedId: "00000000-0000-0000-0000-000000000000",
  });
  const [employeeFollowUpEvents, setEmployeeFollowUpEvents] = useState([]);
  const [currPage, setCurrPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [searchEmployee, setSearchEmployee] = useState(consultantName);
  const [searchDoneBy, setSearchDoneBy] = useState(userName);
  const [eventType, setEventType] = useState(followUpEventType);
  const [employeeList, setEmployeeList] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [doneByList, setDoneByList] = useState([]);
  const [orderBy, setOrderBy] = useState("");
  const [done, setDone] = useState(followUpEventDone);
  const [loading, setLoading] = useState(true);
  const [month, setMonth] = useState(followUpEventMonth);
  const [year, setYear] = useState(followUpEventYear);
  const [excelLoading, setExcelLoading] = useState(false);
  const [assignedToList, setAssignedToList] = useState([]);
  const [followUpEventList, setFollowUpEventList] = useState([]);
  const [unresolvedEmployee, setUnresolvedEmployee] = useState({});

  //
  const [eventFormValues, setEventFormValues] = useState({});
  const [eventValues, setEventValues] = useState({});
  const [cancelEventVisible, setCancelEventVisible] = useState(false);
  const [unresolvedModalVisible, setUnresolvedModalVisible] = useState(false);
  const [cancelEventForm] = Form.useForm();
  const [refetchFollowUpEventData, setRefetchFollowUpEventData] =
    useState(false);
  const [eventEmployeeId, setEventEmployeeId] = useState(null);
  const [eventAssignedToId, setEventAssignedToId] = useState(null);
  const [isManager, setIsManager] = useState(false);

  useEffect(() => {
    document.title = `${appTitle} - ${title}`;
  }, []);

  useEffect(() => {
    getUserById(getAuthenticatedUserId()).then((res) => {
      const NexelOrChiefIds = [1, 2, 3, 20];
      if (
        res.data.departmentId === Departement.Manager &&
        !NexelOrChiefIds.includes(res.data.positionId)
      ) {
        setIsManager(true);
      }
    });
  }, []);

  useEffect(async () => {
    await fetchEmployeeFollowUpEventsData();
  }, [
    currPage,
    orderBy,
    searchEmployee,
    searchDoneBy,
    eventType,
    done,
    month,
    year,
    initValues,
    refetchFollowUpEventData,
  ]);

  useEffect(async () => {
    let HRList = [];
    let ManagerList = [];
    await GetUserByDepartmentId(Departement.HumanResources).then((res) => {
        if (res.status === 200) {
            const filteredHumanResources = res.data.result.filter((hr) => !hr.deleted);
            HRList = filteredHumanResources;
      }
    });
    await GetUserByDepartmentId(Departement.Manager).then((res) => {
        if (res.status === 200) {
            const filteredManagers = res.data.result.filter((manager) => !manager.deleted);
            ManagerList = filteredManagers;
      }
    });
    await getFollowUpEventList(1, 1024, "", "", "", "False").then((res) => {
      //if (res.status === 200) {
      //    setFollowUpEventList(res.data.result);
      //}
      if (res.status === 200) {
        let followUpEventsList = res.data.result;
        let eventList = [];

        followUpEventsList.forEach((elem) => {
          if (eventList.length > 0) {
            let checkUnic = eventList.filter((x) => x.name === elem.name);

            if (checkUnic.length === 0) {
              eventList.push(elem);
            }
          } else {
            eventList.push(elem);
          }
        });

        setFollowUpEventList([...eventList]);
      } else {
        AdnMessageError(
          t("manageEmployeeFollowUpEventList.messages.errorLoadingEventTypes")
        );
      }
    });

      let assignedToList = HRList.concat(ManagerList);
      assignedToList.sort((a, b) =>
          a.name.localeCompare(b.name, 'en', { sensitivity: 'base' })
      );
      setAssignedToList(assignedToList);
  }, [initValues]);

  // useEffect(async () => {
  //   if (initValues.id !== null) {
  //     await updateEmployeeFollowUpEvent(initValues);
  //   }
  // }, [initValues]);

  const fetchEmployeeFollowUpEventsData = async () => {
    await getEmployeeFollowUpEventList(
      currPage,
      orderBy || "",
      eventType || "",
      searchEmployee || "",
      (userName !== "" ? userName : searchDoneBy) || "",
      done !== undefined ? done : "",
      month || "",
      year || ""
    )
      .then((res) => {
        setLoading(false);
        setEmployees(res.data.result);
        setTotalRecords(res.data.totalRecords);
      })
      .catch((error) => {
        console.error("API Error:", error);
        setLoading(false);
        AdnMessageError(
          t("manageEmployeeFollowUpEventList.messages.errorLoadingData")
        );
      });
  };

  const handleOrderList = (pag, filter, sorter) => {
    if (sorter.field?.endsWith("Name"))
      sorter.field = sorter.field.replace("Name", "");
    sorter.order === "descend"
      ? setOrderBy("-" + sorter.field.toLowerCase())
      : sorter.order === "ascend"
      ? setOrderBy(sorter.field.toLowerCase())
      : setOrderBy("");
  };

  const handleSelectEmployee = (employee) => {
    setSearchEmployee(employee);
  };

  const handleSearchEmployee = (value) => {
    value.length >= 3 ? setSearchEmployee(value) : setSearchEmployee("");
  };

  const handleSelectDoneBy = (doneBy) => {
    setSearchDoneBy(doneBy);
  };

  const handleSearchDoneBy = (value) => {
    value.length >= 3 ? setSearchDoneBy(value) : setSearchDoneBy("");
  };

  const meetingStatusOptions = [
    {
      id: 0,
      name: t("manageEmployeeFollowUpEventList.statusOptions.notAssigned"),
    },
    { id: 1, name: t("manageEmployeeFollowUpEventList.statusOptions.notDone") },
    { id: 2, name: t("manageEmployeeFollowUpEventList.statusOptions.done") },
    {
      id: 3,
      name: t("manageEmployeeFollowUpEventList.statusOptions.canceled"),
    },
  ];

  const changeEmployeeList = () => {
    if (searchEmployee.length >= 3) {
      const uniqueEmployees = employees.reduce((acc, e) => {
        if (!acc.find((item) => item.id === e.employeeId)) {
          acc.push({ id: e.employeeId, employeeName: e.employeeName });
        }
        return acc;
      }, []);
      setEmployeeList(uniqueEmployees);
      setCurrPage(1);
    } else {
      setEmployeeList([]);
    }
  };

  const changeDoneByList = () => {
    if (searchDoneBy.length >= 3) {
      const optionValues = [];
      setDoneByList(
        employeeFollowUpEvents
          .map((e) => {
            if (!optionValues.includes(e.doneByName)) {
              optionValues.push(e.doneByName);
              return { id: e.doneByName };
            }
            return null;
          })
          .filter((e) => e !== null && e !== undefined)
      );
      setCurrPage(1);
    } else {
      setDoneByList([]);
    }
  };

  useEffect(() => {
    changeEmployeeList();
  }, [employees, searchEmployee]);

  useEffect(() => {
    changeDoneByList();
  }, [employeeFollowUpEvents, searchDoneBy]);

  const monthHandleChange = (value) => {
    setCurrPage(1);
    if (value !== undefined) {
      setMonth(value);
    } else {
      setMonth("");
    }
  };

  const yearHandleChange = (value) => {
    setCurrPage(1);
    if (value !== undefined) {
      setYear(value);
    } else {
      setYear("");
    }
  };

  const handleEventType = (value) => {
    setCurrPage(1);
    setEventType(value);
  };

  const handleDone = (value) => {
    setCurrPage(1);
    setDone(value);
  };

  const handleGenerateExcel = () => {
    setExcelLoading(true);
    generateAnnualReport().then((res) => {
      const url = window.URL.createObjectURL(
        new Blob([res.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      const a = document.createElement("a");
      a.href = url;
      a.download = t("manageEmployeeFollowUpEventList.excelFileName");
      a.click();
      window.URL.revokeObjectURL(url);
      setExcelLoading(false);
    });
  };

  const handleCancelEventModal = (values) => {
    setEventFormValues(values);
    setCancelEventVisible(true);
  };

  const handleUnCancelEvent = (employeeFollowUpEventId) => {
    reset(employeeFollowUpEventId).then((res) => {
      if (res.status === 200) {
          res.data.status = 0;
          res.data.doneById = null;
          res.data.date = null;
          res.data.feedBack = null;
          res.data.note = null;
          res.data.status = 0;
          res.data.quizStatusId = 0;
          res.data.quizId = null;
          res.data.dlientLevel = null;
          res.data.projectLevel = null;
          res.data.companyLevel = null;
          setEventValues(res.data);
          fetchEmployeeFollowUpEventsData();
      } else {
        AdnMessageError(
          t("manageEmployeeFollowUpEventList.messages.errorUnCancelingEvent")
        );
      }
    });
  };

  const handleCancelEventFinish = (values) => {
    getEmployeeFollowUpEventById(eventFormValues.id).then((res) => {
      if (res.status === 200) {
        res.data.status = 3;
        res.data.note = values.note;
        setEventValues(res.data);
      } else {
        AdnMessageError(
          t("manageEmployeeFollowUpEventList.messages.errorCancelingEvent")
        );
      }
    });
    setCancelEventVisible(false);
  };

  const handleAssignPerson = async (
    employeeFollowUpEventId,
    assignedToId,
    employeeId,
    employeeName
  ) => {
    setEventEmployeeId(employeeFollowUpEventId);
    setEventAssignedToId(assignedToId);
    await checkPreviousUnresolvedEmployeeFollowUpEventsById(
      employeeFollowUpEventId
    ).then(async (res) => {
      if (res.status === 200) {
        if (res.data && res.data.listOfEvents.length > 0) {
          setUnresolvedEmployee({
            employeeId: employeeId,
            employeeName: employeeName,
            listOfEvents: res.data.listOfEvents,
          });
          setUnresolvedModalVisible(true);
        } else {
          confirmAssignPerson(employeeFollowUpEventId, assignedToId);
        }
      }
    });
  };

  const confirmAssignPerson = async (employeeFollowUpEventId, assignedToId) => {
    await getEmployeeFollowUpEventById(employeeFollowUpEventId).then((res) => {
      if (res.status === 200) {
        res.data.doneById = assignedToId;
        if (assignedToId !== null) {
          res.data.status = 1;
        } else {
          res.data.status = 0;
        }
        setEventValues(res.data);
      }
    });
  };

  // useEffect(async () => {
  //   if (eventValues.id !== null) {
  //     await updateEmployeeFollowUpEvent(eventValues).then((res) => {
  //       if (res.status === 200) {
  //         setRefetchFollowUpEventData(!refetchFollowUpEventData);
  //       }
  //     });
  //   }
  // }, [eventValues]);

  const FirstLastName = (name) => {
    let fullName = name.split(" ");
    let firstName = fullName[0];
    return firstName.concat(" " + fullName[fullName.length - 1]);
  };

  const columns = [
    {
      title: t("manageEmployeeFollowUpEventList.columns.event"),
      dataIndex: "eventType",
      key: "eventType",
      sorter: true,
      width: "20%",
    },
    {
      title: t("manageEmployeeFollowUpEventList.columns.consultant"),
      dataIndex: "employeeName",
      key: "employeeName",
      sorter: true,
      width: "15%",
      render: (text, record) => (
        <Link
          to={AppRoutes.consultantById.createPath(record.employeeId)}
          target="_blank"
        >
          {FirstLastName(text)}
        </Link>
      ),
    },
    {
      title: t("manageEmployeeFollowUpEventList.columns.reference"),
      dataIndex: "referenceDate",
      key: "referenceDate",
      render: (text) =>
        text
          ? MonthsPortuguese[parseInt(moment(text).format("MM"))] +
            " " +
            moment(text).format("YYYY")
          : undefined,
      width: "12%",
    },
    {
      title: t("manageEmployeeFollowUpEventList.columns.contractType"),
      dataIndex: "contractType",
      key: "contractType",
      sorter: true,
      width: "15%",
      render: (text) => (text ? text.split(" - ")[0] : text),
    },
    {
      title: t("manageEmployeeFollowUpEventList.columns.manager"),
      dataIndex: "managerAbbreviation",
      key: "managerAbbreviation",
      sorter: true,
      width: "10%",
    },
    {
      title: t("manageEmployeeFollowUpEventList.columns.assignedTo"),
      dataIndex: "doneByName",
      width: "15%",
      render: (text, record) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "100%",
          }}
        >
          {record.status === 0 || record.status === 1 ? (
            <AdnDropdown
              name="doneByName"
              placeholder={t(
                "manageEmployeeFollowUpEventList.placeholders.assignPerson"
              )}
              handleChange={(value) => {
                handleAssignPerson(
                  record.id,
                  value,
                  record.employeeId,
                  record.employeeName
                );
              }}
              defaultValue={text}
              allowClear={true}
              options={assignedToList}
              disabled={isManager}
            />
          ) : (
            <>{text}</>
          )}
        </div>
      ),
    },
    {
      title: t("manageEmployeeFollowUpEventList.columns.status"),
      dataIndex: "status",
      sorter: true,
      width: "10%",
      render: (text, record) =>
        record.status === 0 ? (
          <div className="state-tag tag-to-do">
            {t("manageEmployeeFollowUpEventList.status.notAssigned")}
          </div>
        ) : record.status === 1 ? (
          <div className="state-tag tag-danger">
            {t("manageEmployeeFollowUpEventList.status.notDone")}
          </div>
        ) : record.status === 2 ? (
          <div className="state-tag tag-done">
            {t("manageEmployeeFollowUpEventList.status.done")}
          </div>
        ) : (
          <div className="state-tag tag-canceled">
            {t("manageEmployeeFollowUpEventList.status.canceled")}
          </div>
        ),
    },
    {
      title: t("manageEmployeeFollowUpEventList.columns.actions"),
      key: "action",
      render: (text, record) => (
        <>
          {!isManager && (
            <Space Space style={{ display: "flex", justifyContent: "center" }}>
              {record.status === 0 ? (
                <></>
              ) : (
                <EditOutlined
                  style={{ color: "black", fontSize: "large" }}
                  onClick={() => {
                    navigate(AppRoutes.followUpEventById.createPath(record.id));
                  }}
                />
              )}

              {record.status === 0 || record.status === 1 ? (
                <>
                  <CloseOutlined
                    style={{ color: "red" }}
                    onClick={() => handleCancelEventModal(record)}
                  />
                </>
              ) : record.status === 3 || record.status === 2 ? (
                <Popconfirm
                  title={t(
                    "manageEmployeeFollowUpEventList.confirmations.resetEvent"
                  )}
                  onConfirm={() => {
                    handleUnCancelEvent(record.id);
                  }}
                >
                  <UndoOutlined style={{ color: "blue" }} />
                </Popconfirm>
              ) : (
                <></>
              )}
            </Space>
          )}
        </>
      ),
      width: "10%",
    },
  ];

  const expandedRowRender = (record) => {
    const hasNotes =
      record.note && record.note !== null && record.note.trim() !== "";
    const hasFeedback =
      record.feedBack &&
      record.feedBack !== null &&
      record.feedBack.trim() !== "";

    return (
      <div
        style={{
          padding: "16px",
          backgroundColor: "#fafafa",
          margin: "0 16px",
        }}
      >
        {hasNotes && (
          <p style={{ margin: "0 0 10px 0" }}>
            <strong>{t("manageEmployeeFollowUpEventList.labels.notes")}</strong>{" "}
            {record.note}
          </p>
        )}
        {hasFeedback && (
          <p style={{ margin: "0" }}>
            <strong>
              {t("manageEmployeeFollowUpEventList.labels.feedback")}
            </strong>{" "}
            {record.feedBack}
          </p>
        )}
      </div>
    );
  };

  const rowExpandable = (record) => {
    const hasNotes =
      record.note && record.note !== null && record.note.trim() !== "";
    const hasFeedback =
      record.feedBack &&
      record.feedBack !== null &&
      record.feedBack.trim() !== "";

    return hasNotes || hasFeedback;
  };

  return (
    <EmployeeFollowUpEventListForm
      title={title}
      currPage={currPage}
      totalRecords={totalRecords}
      handleOrderList={handleOrderList}
      handleChangePage={setCurrPage}
      employeeFollowUpEvents={employeeFollowUpEvents}
      columns={columns}
      employeePlaceholder={employeePlaceholder}
      handleSearchEmployee={handleSearchEmployee}
      handleSelectEmployee={handleSelectEmployee}
      doneByPlaceholder={doneByPlaceholder}
      handleSearchDoneBy={handleSearchDoneBy}
      handleSelectDoneBy={handleSelectDoneBy}
      employeeList={employeeList}
      doneByList={doneByList}
      handleEventType={handleEventType}
      meetingStatusOptions={meetingStatusOptions}
      meetingStatusChange={handleDone}
      loading={loading}
      handleMonthChange={monthHandleChange}
      handleYearChange={yearHandleChange}
      searchDoneBy={searchDoneBy}
      done={done}
      month={month}
      year={year}
      employees={employees}
      expandedRowRender={expandedRowRender}
      rowExpandable={rowExpandable}
      rowClassName={(record, index) =>
        moment(record.referenceDate).add(30, "d") < moment(moment()) &&
        (record.status === 0 || record.status === 1)
          ? "lateEventRow"
          : ""
      }
      handleGenerateExcel={handleGenerateExcel}
      excelLoading={excelLoading}
      followUpEventList={followUpEventList}
      cancelEventForm={cancelEventForm}
      cancelEventVisible={cancelEventVisible}
      setCancelEventVisible={setCancelEventVisible}
      handleCancelEventFinish={handleCancelEventFinish}
      unresolvedModalVisible={unresolvedModalVisible}
      setUnresolvedModalVisible={setUnresolvedModalVisible}
      unresolvedEmployee={unresolvedEmployee}
      confirmAssignPerson={confirmAssignPerson}
      eventEmployeeId={eventEmployeeId}
      eventAssignedToId={eventAssignedToId}
    />
  );
};
